import script from "./SiderView.vue?vue&type=script&setup=true&lang=js"
export * from "./SiderView.vue?vue&type=script&setup=true&lang=js"

import "./SiderView.vue?vue&type=style&index=0&id=3ca5b782&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca5b782"]])

export default __exports__